const chatSlice = (set, _) => ({
  messages: [],
  suggestions: [],
  error: null,
  loading: false,
  expanded: false,

  setSuggestions: (suggestions) => set(state => ({ chat: { ...state.chat, suggestions: [...suggestions] }})),
  resetSuggestions: () => set(state => ({ chat: { ...state.chat, suggestions: [] }})),
  
  setMessages: (messages) => set(state => ({ chat: { ...state.chat, messages: [...messages] }})),
  addMessage: (message) => set(state => ({ chat: { ...state.chat, messages: [...state.chat.messages, message] }})),
  resetMessages: () => set(state => ({ chat: { ...state.chat, messages: [] }})),

  setError: (error) => set(state => ({ chat: { ...state.chat, error }})),
  resetError: () => set(state => ({ chat: { ...state.chat, error: null }})),

  setLoading: (loading) => set(state => ({ chat: { ...state.chat, loading }})),

  setExpanded: (expanded) => set(state => ({ chat: { ...state.chat, expanded }}))
});

export default chatSlice;